var _path, _g, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 39,
    viewBox: "0 0 33 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3286_1645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 0H0V39H33V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3286_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.57 29.4648L20.3744 36.5747C18.7391 38.8125 15.3993 38.8125 13.764 36.5747L8.56836 29.4648H25.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 32.7052C25.474 32.7052 32.5714 25.6077 32.5714 16.8526C32.5714 8.09745 25.474 1 16.7188 1C7.96366 1 0.866211 8.09745 0.866211 16.8526C0.866211 25.6077 7.96366 32.7052 16.7188 32.7052Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4594 11.3076V11.2453L20.4345 11.1208C20.3847 10.4857 19.8492 10 19.2141 10C18.6786 10 18.2054 10.3238 18.0186 10.8219L17.7571 10.8344C14.2079 10.934 11.3686 13.8231 11.3188 17.3848L8.31756 19.7135L8.24284 19.7882C7.91905 20.112 7.91905 20.6351 8.24284 20.9588C8.47945 21.2079 8.80323 21.3449 9.13947 21.3449C9.20174 21.3449 9.264 21.3324 9.32627 21.3324L9.74968 21.2826L9.87421 21.2702C10.0984 21.2702 10.4471 21.3075 10.9701 21.5441C11.1195 21.6189 11.269 21.6811 11.4184 21.7434L12.2901 22.1543C12.7135 22.3536 13.137 22.5279 13.5728 22.7023C14.4196 23.0385 15.2914 23.2751 16.2378 23.2751C18.0809 23.2751 19.9613 22.3536 22.3274 20.0747C22.8256 20.0497 23.3237 19.9999 23.8467 19.9501C24.2701 19.9128 24.5939 19.5516 24.5939 19.1282V17.2353C24.5067 14.6077 22.8878 12.2914 20.4594 11.3076ZM16.2378 21.6189C15.5778 21.6189 14.9178 21.4445 14.1706 21.1581C13.8841 21.046 13.5853 20.9215 13.2864 20.7845L12.0037 20.1867L11.6426 20.0248C11.3935 19.9128 11.1569 19.838 10.9452 19.7758L12.5517 18.518L13.0373 18.6923C15.4034 19.5392 17.5578 19.975 19.7994 20.0871C18.2926 21.2702 17.1967 21.6189 16.2378 21.6189ZM19.7745 18.4184C17.5454 18.2938 15.4159 17.8206 13.0124 16.9115C13.2988 14.396 15.4159 12.4906 17.9688 12.4906C18.1182 12.4906 18.2801 12.4906 18.442 12.5031C18.853 13.051 19.3137 13.9228 19.6002 14.9813C19.8866 16.0772 19.9987 17.2851 19.7745 18.4184ZM22.9501 18.3686C22.452 18.4059 21.9538 18.4308 21.4557 18.4433C21.6674 17.0983 21.518 15.7409 21.2066 14.5579C21.0946 14.1469 20.9576 13.7484 20.8081 13.3748C22.1531 14.3088 22.9501 15.8406 22.9501 17.4719V18.3686Z",
    fill: "#FFAE4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9503 17.4711V18.3678C22.4522 18.4051 21.954 18.43 21.4559 18.4425C21.6676 17.0975 21.5182 15.7401 21.2069 14.5571C21.0948 14.1461 20.9578 13.7476 20.8083 13.374C22.1408 14.308 22.9503 15.8398 22.9503 17.4711Z",
    fill: "#FFD7A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7998 20.0867C18.293 21.2697 17.1846 21.6184 16.2382 21.6184C15.5782 21.6184 14.9181 21.4441 14.1709 21.1577C13.8845 21.0456 13.5856 20.921 13.2868 20.7841L12.0041 20.1863L11.6429 20.0244C11.3939 19.9123 11.1573 19.8376 10.9456 19.7754L12.552 18.5176L13.0377 18.6919C15.4163 19.5387 17.5582 19.9746 19.7998 20.0867Z",
    fill: "#FFEAD3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7742 18.418C17.5451 18.2934 15.4156 17.8202 13.0121 16.9111C13.2985 14.3956 15.4156 12.4902 17.9685 12.4902C18.1179 12.4902 18.2798 12.4902 18.4417 12.5027C18.8526 13.0506 19.3134 13.9224 19.5998 14.9809C19.8863 16.0768 19.9983 17.2847 19.7742 18.418Z",
    fill: "#FFD7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalMapIcon);
export default __webpack_public_path__ + "static/media/personalMapIcon.705235687149b5c3ce66602a339dedee.svg";
export { ForwardRef as ReactComponent };